export enum ServiceCategory {
  Documents = 'Documents',
  Visa = 'Visa',
  Registration = 'Registration',
  Other = 'Other'
}

export interface LocalizedText {
  en: string;
  ar: string;
  fr: string;
}

export interface TimeWindow {
  start: string;
  end: string;
}

export interface DaySchedule {
  open: boolean;
  windows: TimeWindow[];
}

export interface WeeklySchedule {
  monday: DaySchedule;
  tuesday: DaySchedule;
  wednesday: DaySchedule;
  thursday: DaySchedule;
  friday: DaySchedule;
  saturday: DaySchedule;
  sunday: DaySchedule;
}

export interface ScheduleException {
  date: string; // ISO date string
  closed?: boolean;
  windows?: TimeWindow[];
}

export interface Fee {
  amount: number;
  currency: string;
}

export interface IService {
  id: string;
  name: LocalizedText;
  description: LocalizedText;
  requirements?: LocalizedText;
  termsOfServices?: LocalizedText;
  iconUrl: string;
  category: ServiceCategory;
  fee?: Fee;
  serviceTimeMinutes: number;
  maxAppointmentsPerDay?: number;
  maxAdvanceDays?: number;
  weeklySchedule: WeeklySchedule;
  exceptions: ScheduleException[];
  createdAt?: string;
  updatedAt?: string;
}

export interface ICreateServiceModel {
  en_Name: string;
  ar_Name: string;
  fr_Name: string;
  en_Description: string;
  ar_Description: string;
  fr_Description: string;
  en_RequirementsHtml?: string;
  ar_RequirementsHtml?: string;
  fr_RequirementsHtml?: string;
  icon: File;
  category: string;
  feeAmount?: number;
  feeCurrency?: string;
  serviceTimeMinutes: number;
  slotCapacity?: number;
  bufferMinutesBetweenSlots?: number;
  maxAppointmentsPerDay?: number;
  minAdvanceMinutes?: number;
  maxAdvanceDays?: number;
  weeklyScheduleJson: string;
  exceptionsJson?: string;
}

export interface IUpdateServiceModel {
  id: string;
  en_Name?: string;
  ar_Name?: string;
  fr_Name?: string;
  en_Description?: string;
  ar_Description?: string;
  fr_Description?: string;
  en_RequirementsHtml?: string;
  ar_RequirementsHtml?: string;
  fr_RequirementsHtml?: string;
  icon?: File;
  iconUrl?: string;
  category?: string;
  feeAmount?: number;
  feeCurrency?: string;
  serviceTimeMinutes?: number;
  slotCapacity?: number;
  bufferMinutesBetweenSlots?: number;
  maxAppointmentsPerDay?: number;
  minAdvanceMinutes?: number;
  maxAdvanceDays?: number;
  weeklyScheduleJson?: string;
  exceptionsJson?: string;
}

export interface IAppointment {
  id: string;
  serviceId: string;
  contactId: string;
  appointmentDate: string;
  startTime: string;
  endTime: string;
  status: 'Pending' | 'Confirmed' | 'Cancelled' | 'Processed';
  serviceName?: string;
  contactName?: string;
}
